module.exports = __webpack_public_path__ + "img/12.243a7fbd.jpg";